module.exports = __webpack_public_path__ + "static/media/icon_filter_black.4d8c5ae3.svg";